import { render, staticRenderFns } from "./reports-ram-signed-sheets.vue?vue&type=template&id=32a6c342&scoped=true"
import script from "./reports-ram-signed-sheets.vue?vue&type=script&lang=js"
export * from "./reports-ram-signed-sheets.vue?vue&type=script&lang=js"
import style0 from "./reports-ram-signed-sheets.vue?vue&type=style&index=0&id=32a6c342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a6c342",
  null
  
)

export default component.exports